export enum CreationMode {
    SameValues = 'SameValues',
    DifferentValues = 'DifferentValues',
}
